import { isElectronApp } from '#~/electron/utils.js';
import { NotFound } from '../not-found/not-found.js';
import { Outlet } from 'react-router-dom';

export const ElectronProtect = () => {
  if (isElectronApp()) {
    return <Outlet />;
  }

  return <NotFound />;
};
